import { useTranslation } from "react-i18next";
import { SubTask, SubTaskGroup, SubTaskRole } from "../../interfaces/Task";
import { useEffect } from "react";

export interface SiteSubTaskRoleProps {
    role: SubTaskRole;
    subTask: SubTask
}

export default function SiteSubTaskRole(props: SiteSubTaskRoleProps) {
    const { t } = useTranslation();

    console.log('SiteSubTaskRole - Role:', props.role.name);
    console.log('SiteSubTaskRole - Role groups indices:', props.role.groups);
    console.log('SiteSubTaskRole - SubTask groups:', props.subTask.groups.map((g, i) => ({ index: i, name: g.name })));

    const itemStyle = {
        backgroundColor: props.role.color
    }

    const roleAssignment = (id: string, groups: SubTaskGroup[], roles: SubTaskRole[]) => {
        let numAssignments = 0;
        for (let i = 0; i < groups.length; i++) {
            const students = groups[i].students;
            for (let j = 0; j < students.length; j++) {
                if (students[j].role != -1) {
                    if (roles[students[j].role]._id == id) {
                        numAssignments++;
                    }
                }
            }
        }
        if (numAssignments == 0) {
            return t("not used");
        } else {
            return t("used by") + ' ' + numAssignments + ' ' + t("students");
        }
    }

    // Calculate which groups this role belongs to based on which students use it
    const getGroupsForRole = (roleId: string) => {
        const groupIndices: number[] = [];
        const roleIndex = props.subTask.roles.findIndex((r: SubTaskRole) => r._id === roleId);

        if (roleIndex === -1) return groupIndices;

        props.subTask.groups.forEach((g: SubTaskGroup, groupIndex: number) => {
            const roleUsedInGroup = g.students.some((s) => s.role === roleIndex);
            if (roleUsedInGroup && !groupIndices.includes(groupIndex)) {
                groupIndices.push(groupIndex);
            }
        });

        return groupIndices;
    };

    const belongsToGroups = getGroupsForRole(props.role._id);

    return(
        <div className="site-sub-task-role-container" key={ 'sub-task-role-' + props.role._id }>
            <div className="color" style={ itemStyle }></div>
            <div className="title">{ props.role.name } { '(' + roleAssignment(props.role._id, props.subTask.groups, props.subTask.roles)  + ')'}</div>
            { belongsToGroups.length > 0 &&
                <div className="groups-belong">
                    <strong>{ t("Belongs to groups") }:</strong>
                    { props.subTask.groups.map((g: SubTaskGroup, index) => {
                        if (belongsToGroups.indexOf(index) !== -1) {
                            const groupItemStyle = {
                                backgroundColor: g.color
                            }
                            return <span className="group-assigned" key={'group-assigned-' + index}>
                                    <span style={ groupItemStyle }></span> { g.name }
                                </span>;
                        }
                        return null;
                    })}
                </div>
            }
        </div>
    );
}